import { render, staticRenderFns } from "./driverRz.vue?vue&type=template&id=24148cb0&scoped=true"
import script from "./driverRz.vue?vue&type=script&lang=js"
export * from "./driverRz.vue?vue&type=script&lang=js"
import style0 from "./driverRz.vue?vue&type=style&index=0&id=24148cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24148cb0",
  null
  
)

export default component.exports